import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetTrashAssetsQueryVariables = Types.Exact<{
  page: Types.PageInput;
  projectId: Types.Scalars['ID']['input'];
  query: Types.TrashAssetsQueryInput;
}>;


export type GetTrashAssetsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, trashAssets?: { __typename?: 'TrashAssetsConnection', totalCount: number, nodes: Array<{ __typename?: 'CollectionAsset', id?: string | null } | null>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } | null } | null } | null };


export const GetTrashAssets = /*#__PURE__*/ gql`
    query GetTrashAssets($page: PageInput!, $projectId: ID!, $query: TrashAssetsQueryInput!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      trashAssets(page: $page, query: $query) {
        totalCount
        nodes {
          id
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetTrashAssetsQuery, GetTrashAssetsQueryVariables>;

          

          export const useGetTrashAssetsQuery = (options?:QueryHookOptions<GetTrashAssetsQuery, GetTrashAssetsQueryVariables>) => useQuery(GetTrashAssets, options);

          

          export type GetTrashAssetsQueryOptions = QueryHookOptions<GetTrashAssetsQuery, GetTrashAssetsQueryVariables>;

          

          export const useGetTrashAssetsLazyQuery = (options?:LazyQueryHookOptions<GetTrashAssetsQuery, GetTrashAssetsQueryVariables>) => useLazyQuery(GetTrashAssets, options);

          

          export type GetTrashAssetsQueryResult = ReturnType<typeof useGetTrashAssetsQuery>;

          
